export function countryCurrencyNumberFormat(locale, currency, number) {
  try {
    return new Intl.NumberFormat(locale, {style: 'currency', currency}).format(number);
  } catch (err) { // In case of error return currency code and value
    console.log(err);
    return `${currency} ${number}`;
  }
}
